import { CSSProperties, FC, Fragment } from "react";

import styles from "./styles.module.scss";

interface SkeletonProps {
	circle?: boolean;
	count?: number;
	inline?: boolean;
	height?: number;
	width?: number;
	style?: CSSProperties;
}

export const Skeleton: FC<SkeletonProps> = ({
	height,
	circle = false,
	width,
	count = 1,
	inline = false,
	style,
}) =>
	new Array(count).fill(null).map((_, i) => (
		<Fragment key={i}>
			<span
				className={`${styles.skeleton} ${styles[circle ? "skeleton-circle" : "skeleton-text"]}`}
				style={{
					// Default as span as block to act like a div
					// in case Skeleton is nested inside a p tag for valid HTML
					display: "block",
					...style,
					height,
					width,
				}}
			/>
			{!inline && <br />}
		</Fragment>
	));
